import { StrictMode } from 'react'
import { createRoot, hydrateRoot } from 'react-dom/client'
import App, { routeFromBrowser } from './App'
import { legacyHashPath } from './routes'
import './styles.css'

const root = document.getElementById('root')
if (!root) throw new Error('Missing #root')

const siteUrl = document.documentElement.dataset.siteUrl
if (!siteUrl) throw new Error('Missing prerendered site URL')

const hadLegacyHash = Boolean(legacyHashPath(window.location.hash))
const app = (
  <StrictMode>
    <App initialRoute={routeFromBrowser()} siteUrl={siteUrl} />
  </StrictMode>
)

if (hadLegacyHash) {
  createRoot(root).render(app)
} else {
  hydrateRoot(root, app)
}

if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      // Offline support is an enhancement; local processing remains available.
    })
  })
}
